<template>
  <CErrorFullScreen
    class="pa-10 rounded-2"
    :description="t('canvasUI.smartFolders.smartFoldersMissingConfig.noConfigDescription')"
    fit-parent
    icon="face-dotted"
    :title="t('canvasUI.smartFolders.smartFoldersMissingConfig.pleaseConfigureSmartFolders')"
  >
    <CButton v-if="!hideConfigurationButton" class="mt-3" @click="emit('configure')">
      <template #icon>
        <CIcon icon="cog" />
      </template>
      {{ t('canvasUI.smartFolders.smartFoldersMissingConfig.configureSmartFolders') }}
    </CButton>
  </CErrorFullScreen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CErrorFullScreen from '@lib/components/CError/CErrorFullScreen.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'

withDefaults(
  defineProps<{
    hideConfigurationButton?: boolean
  }>(),
  {
    hideConfigurationButton: false,
  },
)

const emit = defineEmits<{
  configure: []
}>()

const { t } = useI18n()
</script>
